<template>
  <div v-if="applicant && applicant.id" id="applicant-edit-tab-l1">
    <div class="vx-col w-full md:w-3/4">
      <div class="mt-4 vx-row w-full">
        <div class="vx-col w-1/4">L1 Person ID:</div>
        <div class="vx-col w-3/4">
          {{ applicant.l1ID || "-" }}
        </div>
      </div>
      <div class="mt-4 vx-row w-full">
        <div class="vx-col w-1/4">Letzte Synchronisation:</div>
        <div class="vx-col w-3/4">
          {{ applicant.l1syncTime || "-" }}
        </div>
      </div>
      <p class="mt-4 text-lg">
        <vs-button class="mt-3" :disabled="!canUpdate" @click="l1Update"
          >In L1 Synchronisieren</vs-button
        >
      </p>
      <div class="mt-2">
        <div v-if="!applicant.birthday" class="mt-1 text-danger">
          Geburtsdatum muss ausgefüllt sein
        </div>
        <div v-if="!applicant.privacyPolicyAccepted" class="mt-1 text-danger">
          Datenschutzerklärung muss aktzeptiert sein
        </div>
        <div v-if="!applicant.salutation" class="mt-1 text-danger">
          Anrede muss ausgewählt sein
        </div>
        <div v-if="applicant.l1UpdateRequested" class="mt-1 text-danger">
          Es ist bereits eine Synchronisation in Arbeit
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            salutation
            birthday
            privacyPolicyAccepted
            l1UpdateRequested
            l1ID
            l1sync
            l1syncTime
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  computed: {
    canUpdate() {
      return (
        this.applicant &&
        !this.applicant.l1UpdateRequested &&
        this.applicant.birthday &&
        this.applicant.privacyPolicyAccepted &&
        this.applicant.salutation
      );
    }
  },
  methods: {
    async l1Update() {
      this.applicant.l1UpdateRequested = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!) {
            requestApplicantL1Update(id: $id)
          }
        `,
        variables: {
          id: this.applicant.id
        }
      });

      this.$vs.notify({
        title: "Synchronisation gestartet",
        text: "Der Vorgang sollte maximal 5 Minuten in Anspruch nehmen.",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });
    }
  }
};
</script>
